var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningExclamatoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcae3f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57,48a9,9,0,1,0,9,9A9.01,9.01,0,0,0,57,48Zm0,13.842a.865.865,0,1,1,.865-.865A.865.865,0,0,1,57,61.842Zm.94-8.7-.248,5.279a.692.692,0,0,1-1.385,0l-.248-5.276v0a.941.941,0,1,1,1.88,0Z",
    transform: "translate(-48 -48)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningExclamatoryIcon);
export default __webpack_public_path__ + "static/media/warning-exclamatory-icon.d27e95003e366e496212c1dac89a613a.svg";
export { ForwardRef as ReactComponent };